import { LoginUser } from "models/LoginUser";
import { Reducer } from 'redux';
import { ILoginUserActions, LoginUserActionType } from "redux/actions/LoginUserActions";
const initialState: LoginUser = LoginUser.empty();

export const loginUserReducer: Reducer<LoginUser, ILoginUserActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case LoginUserActionType.LOGIN_USER_SUCCESS:
            case LoginUserActionType.SETNEW_PASSWORD_SUCCESS:
                {
                    localStorage.setItem('token', action.token);
                    return { ...state, token: action.token };
                }
            case LoginUserActionType.LOGOFF_USER:
            case LoginUserActionType.DELETE_ACCOUNT_SUCCESS:
                {
                    localStorage.setItem('token', "");
                    window.location.reload();
                    return { ...state, token: action.token }
                }
            case LoginUserActionType.CONFIRM_DELETE_ACCOUNT_SUCCESS:
                {
                    // no reload here, the middleware moves on to the farewell page
                    localStorage.setItem('token', "");
                    return { ...state, token: "" }
                }
            case LoginUserActionType.FETCH_USERDATA_SUCCESS:
                {
                    let newLoginUser = Object.assign({}, state)
                    newLoginUser.userData = action.returnPayload;
                    return newLoginUser;
                }
            case LoginUserActionType.FETCH_SETTINGS_SUCCESS:
            case LoginUserActionType.UPDATE_SETTINGS_SUCCESS:
                return { ...state, settings: action.returnPayload };
            case LoginUserActionType.ADD_ROLE_LOGIN_USER_SUCCESS:
            case LoginUserActionType.REMOVE_ROLE_LOGIN_USER_SUCCESS:
                {
                    let newLoginUser = Object.assign({}, state)
                    const retUser = action.returnPayload as LoginUser;
                    newLoginUser.email = retUser.email;
                    newLoginUser.userData!.roles = retUser.userData!.roles;
                    newLoginUser.userName = retUser.userName;
                    return newLoginUser;
                }
            default:
                return state;
        }
    };



